import { useState } from 'react';
import type { AssistantTask, UpdateTaskInput } from '@accounting/shared';

export function TaskEditor({
  task,
  busy,
  error,
  onSave,
  onClose,
}: {
  task: AssistantTask;
  busy?: boolean;
  error?: string | null;
  onSave: (patch: UpdateTaskInput) => void;
  onClose: () => void;
}) {
  const [title, setTitle] = useState(task.title);
  const [notes, setNotes] = useState(task.notes ?? '');
  const [dueDate, setDueDate] = useState(task.dueDate ?? '');
  const [priority, setPriority] = useState<'high' | 'low' | ''>(task.priority ?? '');
  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div className="modal pa-detail" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Edit task">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <h2 style={{ margin: 0, fontSize: 18, flex: 1 }}>{task.canWrite ? 'Edit task' : 'Task'}</h2>
          <button type="button" className="link-button" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <form
          className="pa-form"
          onSubmit={(e) => {
            e.preventDefault();
            if (!title.trim()) return;
            onSave({ title: title.trim(), notes: notes.trim() || null, dueDate: dueDate || null, priority: priority || null });
          }}
        >
          <label>
            Title
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} disabled={!task.canWrite} autoFocus />
          </label>
          <div className="pa-form__row">
            <label>
              Due
              <input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} disabled={!task.canWrite} />
            </label>
            <label>
              Priority
              <select value={priority} onChange={(e) => setPriority(e.target.value as 'high' | 'low' | '')} disabled={!task.canWrite}>
                <option value="">Normal</option>
                <option value="high">High</option>
                <option value="low">Low</option>
              </select>
            </label>
          </div>
          <label>
            Notes
            <textarea rows={4} value={notes} onChange={(e) => setNotes(e.target.value)} disabled={!task.canWrite} />
          </label>
          {task.matterRef && <p className="muted" style={{ margin: 0 }}>Matter {task.matterRef}</p>}
          {task.webLink && (
            <p style={{ margin: 0 }}>
              <a href={task.webLink} target="_blank" rel="noopener noreferrer">Open at the source</a>
            </p>
          )}
          {error && <div className="field-error">{error}</div>}
          {task.canWrite && (
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button type="button" className="btn-secondary" onClick={onClose} disabled={busy}>Cancel</button>
              <button type="submit" className="btn-primary" disabled={busy}>{busy ? 'Saving…' : 'Save'}</button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
